<template>
<div class="chapter">
<div class="inner_page">
<div class="copyrightPage" id="copyrightPage">
<p class="copyrightTextH">Published by</p>
<p class="copyrightText">Grub Street</p>
<p class="copyrightText">4 Rainham Close</p>
<p class="copyrightText">London</p>
<p class="copyrightText">SW11 6SS</p>
<p class="copyrightTextHA">Copyright © 2008 Grub Street</p>
<p class="copyrightText1">Copyright text © 2008 Norman Franks and</p>
<p class="copyrightText1">Wing Commander Bob Foster DFC AE</p>
<p class="copyrightTextHA"><span class="bold">A CIP catalogue record for this book is available from the British Library</span></p>
<p class="copyrightTextHA"><span class="bold">ISBN 978 1 906502 26 3</span></p>
<p class="copyrightText"><span class="bold">eISBN 9781908117588</span></p>
<p class="copyrightTextHA">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the copyright owner.</p>
<p class="copyrightTextHA">Cover design by Lizzie B Design</p>
<p class="copyrightTextHA">Formatted by Pearl Graphics, Hemel Hempstead</p>
<p class="copyrightTextHA">Printed and bound by MPG Ltd, Bodmin, Cornwall</p>
<p class="copyrightTextHA">Grub Street only uses FSC</p>
<p class="copyrightText2">(Forest Stewardship Council) paper for its books.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_TallyHo_copyright.vue?080796a8